import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  dialogClose: {
    marginLeft: 'auto',
    padding: theme.spacing(3),
    paddingTop: 19,
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
  },
  link: {
    fontWeight: 700,
    marginRight: 14,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    margin: [theme.spacing(3), 0],
    textAlign: 'center',
  },
  action: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    margin: [0, theme.spacing(3)],
  },
}));



// WEBPACK FOOTER //
// ./src/components/ResetPassword/useStyles.js